import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import EloHeading from '../Heading/Heading';
import Text from '../Text/Text';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Heading = function Heading(_ref) {
  var children = _ref.children,
    description = _ref.description;
  return ___EmotionJSX("div", {
    css: headingStyles
  }, ___EmotionJSX(EloHeading, {
    noParagraph: true,
    element: "h1"
  }, children), description && ___EmotionJSX(Text, {
    semibold: true,
    shy: true,
    size: "t3",
    style: {
      marginTop: theme.spacings.xxxSmall
    }
  }, description));
};
var headingStyles = function headingStyles() {
  return /*#__PURE__*/css("p{margin-top:", theme.spacings.xxxSmall, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hlYWRlci9IZWFkaW5nLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0QitCIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hlYWRlci9IZWFkaW5nLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5cbmltcG9ydCBFbG9IZWFkaW5nIGZyb20gJy4uL0hlYWRpbmcvSGVhZGluZydcbmltcG9ydCBUZXh0IGZyb20gJy4uL1RleHQvVGV4dCdcblxuaW1wb3J0IHsgZWxvIGFzIHRoZW1lIH0gZnJvbSAnLi4vLi4vdGhlbWVzJ1xuXG5jb25zdCBIZWFkaW5nID0gKHsgY2hpbGRyZW4sIGRlc2NyaXB0aW9uIH0pID0+IChcbiAgPGRpdiBjc3M9e2hlYWRpbmdTdHlsZXN9PlxuICAgIDxFbG9IZWFkaW5nIG5vUGFyYWdyYXBoIGVsZW1lbnQ9J2gxJz5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L0Vsb0hlYWRpbmc+XG5cbiAgICB7ZGVzY3JpcHRpb24gJiYgKFxuICAgICAgPFRleHRcbiAgICAgICAgc2VtaWJvbGRcbiAgICAgICAgc2h5XG4gICAgICAgIHNpemU9J3QzJ1xuICAgICAgICBzdHlsZT17eyBtYXJnaW5Ub3A6IHRoZW1lLnNwYWNpbmdzLnh4eFNtYWxsIH19XG4gICAgICA+XG4gICAgICAgIHtkZXNjcmlwdGlvbn1cbiAgICAgIDwvVGV4dD5cbiAgICApfVxuICA8L2Rpdj5cbilcblxuY29uc3QgaGVhZGluZ1N0eWxlcyA9ICgpID0+IGNzc2BcbiAgcCB7XG4gICAgbWFyZ2luLXRvcDogJHt0aGVtZS5zcGFjaW5ncy54eHhTbWFsbH07XG4gIH1cbmBcblxuSGVhZGluZy5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxuICBkZXNjcmlwdGlvbjogUHJvcFR5cGVzLm9uZU9mVHlwZShbUHJvcFR5cGVzLnN0cmluZywgUHJvcFR5cGVzLm5vZGVdKSxcbn1cblxuZXhwb3J0IGRlZmF1bHQgSGVhZGluZ1xuIl19 */"));
};
Heading.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default Heading;